<script setup>
/**
 * The Journal (journal redesign 2026-10-27): the book the seeker keeps. Shown
 * under Altar › Journal and in the gift room's Journal sheet. Everything lives
 * in `components/journal/` (JournalBook and its pages); this keeps the name and
 * the props both hosts already pass.
 *
 * Gone with the redesign: the Received / Sent shelf (a gift now lives on its
 * day), the always-on "Your Day" box, the pill tabs, and "Visited Mystics &
 * Drops" (a Mystic's message is taped in on the day it came).
 */
import JournalBook from '@/components/journal/JournalBook.vue'

defineProps({
  // Kept for the hosts; the book always has search, and reads its own days.
  searchable: { type: Boolean, default: false },
  visits: { type: Array, default: () => [] },
  drops: { type: Array, default: () => [] },
  // The page to open on (YYYY-MM-DD), from the URL ?day=.
  initialDay: { type: String, default: '' },
  // Opened from the room's "I've kept these for you." (R5.6, R5.7): the gift's page.
  openReceived: { type: Boolean, default: false },
})

// 'close' (a host's sheet), 'dayChange' (mirrored into ?day=), 'seen' (the new
// entry was read: the Journal tab's gold dot goes out).
const emit = defineEmits(['close', 'dayChange', 'seen'])
</script>

<template>
  <div class="history-container">
    <JournalBook :initial-day="initialDay" :open-received="openReceived"
                 @close="emit('close')" @day-change="emit('dayChange', $event)" @seen="emit('seen', $event)" />
  </div>
</template>

<style scoped>
/* The book fills whatever its host gives it. */
.history-container { position: absolute; inset: 0; }
</style>
